import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  UncontrolledAccordion,
  Badge,
  Label, Input
} from "reactstrap";
import { get, post } from "../../helpers/api_helper";
import { SHOW_LOGGER, CLEAR_LOGGER, FREE_DRIVER, FREE_ORDER, SEARCH_TIMESLOT } from "helpers/api_endpoints";
import { Trans } from 'react-i18next';
import Select from "react-select";

document.title = "Collection Hub Logs";

const CollectionHubLogs = () => {
  const [loading, setLoading] = useState(false);
  const [orderDate, setOrderDate] = useState("");
  const [orderTime, setOrderTime] = useState("");
  const [driverId, setDriverId] = useState("");
  const [orderId, setOrderId] = useState("");
  const [response, setResponse] = useState("");
  const [direct, setDirect] = useState(0);
  const [timeSlotId, setTimeSlotId] = useState(0);
  const [colName, setColName] = useState([]);


  // useEffect(() => {
  //   // setLoading(true);
  //   processLog();
  // }, [orderDate, orderTime]);

  const processLog = () => {
    try {
      post(SHOW_LOGGER, {date: orderDate, time: orderTime, direct, timeSlotId}).then(response => {
        console.log('response.log.name', response.log)
        setColName(response.log);
        // setColDesciption(response.log.description);
        setLoading(false);
      })     
    }
    catch(error) {
      console.log('logger error', error);
      setLoading(false);
    }
  }

  const freeDriver = () => {
    try {
      post(FREE_DRIVER, {driverId: driverId}).then(response => {
        setLoading(false);
        setResponse(response?.status);
        setTimeout(() => {
          setResponse('');
        }, 3000);
      })     
    }
    catch(error) {
      console.log('logger error', error);
      setLoading(false);
    }
  }

  const freeOrder = () => {
    try {
      post(FREE_ORDER, {orderId: orderId}).then(response => {
        setLoading(false);
        setResponse(response?.status);
        setTimeout(() => {
          setResponse('');
        }, 3000);
      })     
    }
    catch(error) {
      console.log('logger error', error);
      setLoading(false);
    }
  }

  const clearLog = () => {
    try {
      post(CLEAR_LOGGER, {date: orderDate, time: orderTime}).then(response => {
        setColName('Log cleared');
        // setColDesciption(response.log.description);
        setLoading(false);
      })     
    }
    catch(error) {
      console.log('logger error', error);
      setLoading(false);
    }
  }

  const setCheckDirect = () => {
    if(direct == 0)
      setDirect(1);
    else
      setDirect(0);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Direct Delivery" breadcrumbItem="Direct Delivery Logs" />
          <Label className="form-label">Response : <Trans>{response}</Trans></Label>
          <Row className="d-flex flex-row justify-content-between align-items-center">
            <Col>
              <Row>
                <div className="form-group col-md-2 mt-2">
                  <Label className="form-label"><Trans>Date</Trans></Label>
                  <Input
                  name="orderDate"
                  value={orderDate}
                  className="form-control"
                  placeholder="Enter Date "
                  type="date"
                  onChange={(e) => setOrderDate(e.target.value)}
                  ></Input>
                </div>
                <div className="form-group col-md-2 mt-2">
                  <Label className="form-label"><Trans>Time</Trans></Label>
                  <Input
                  name="orderTime"
                  value={orderTime}
                  className="form-control"
                  placeholder="Enter Time "
                  type="time"
                  onChange={(e) => setOrderTime(e.target.value)}
                  ></Input>
                </div>
								<div className="form-group col-md-1 mt-2">
									<Label className="form-label"><Trans>Timeslot id</Trans></Label>
                  <Input
                  name="timeslotId"
                  className="form-control"
                  placeholder="Enter id "
                  type="text"
                  onChange={(e) => setTimeSlotId(e.target.value)}
                  ></Input>
								</div>
                <div className="form-group col-md-2 mt-2">
                  <Label className="form-label"><Trans>Clear Logs</Trans></Label>
                  <Input
                  name="clear"
                  value="Clear"
                  className="form-control"
                  placeholder="Clear Logs "
                  type="button"
                  onClick={(e) => clearLog()}
                  ></Input>
                </div>
                <div className="form-group col-md-2 mt-2">
                  <Label className="form-label"><Trans>Include direct</Trans></Label>
                  <Input
                  name="run"
                  className="form-control"
                  placeholder=" Logs "
                  type="checkbox"
                  onChange={(e) => setCheckDirect()}
                  ></Input>
                  <Label className="form-label"><Trans>Run algorithm</Trans></Label>
                  <Input
                  name="run"
                  value="Run"
                  className="form-control"
                  placeholder=" Logs "
                  type="button"
                  onClick={(e) => processLog()}
                  ></Input>
                </div>
                <div className="form-group col-md-1 mt-2">
                  <Label className="form-label"><Trans>Free the driver</Trans></Label>
                  <Input
                  name="driverId"
                  className="form-control"
                  placeholder="Driver ID"
                  type="text"
                  onChange={(e) => setDriverId(e.target.value)}
                  ></Input>
                  <Input
                  name="updateDriver"
                  value="Free driver"
                  className="form-control"
                  placeholder="  "
                  type="button"
                  onClick={(e) => freeDriver()}
                  ></Input>
                </div>
                <div className="form-group col-md-1 mt-2">
                  <Label className="form-label"><Trans>Free the order</Trans></Label>
                  <Input
                  name="orderId"
                  className="form-control"
                  placeholder="Order ID"
                  type="text"
                  onChange={(e) => setOrderId(e.target.value)}
                  ></Input>
                  <Input
                  name="updateDriver"
                  value="Free order"
                  className="form-control"
                  placeholder="  "
                  type="button"
                  onClick={(e) => freeOrder()}
                  ></Input>
                </div>
              </Row>
            </Col>

          </Row>

          <Form>

            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    {loading ? (
                      <div className="text-center">
                        {/* <Spinner color="primary" /> */}
                        <span className="ms-2">Loading logs... {loading}</span>
                      </div>
                    ) :
                      colName?.map((el, i) => (
                        <UncontrolledAccordion key={i} stayOpen>
                          <Row>
                            <div className="text-center">
                              <b><span className="ms-2">{el?.name.replace('T', ' - ')}</span></b>
                            </div>
                            <div className="" style={{backgroundColor:'#ccf'}}>
                            {el?.description?.split('##').map((chunck, i) => (
                              <div className="text-left" key={i} style={{backgroundColor:chunck.indexOf('=') > -1?'#d88':(chunck.indexOf('$') > -1?'#bee':'#ccb')}}>
                                    <Badge color="success">{chunck.split(':')[0]+':'+chunck.split(':')[1]}</Badge>
                                    <span className="ms-2" >{chunck}</span>
                              </div>

                            ))}
                            </div>
                          </Row>
                        </UncontrolledAccordion>
                      ))
                    
                  }
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CollectionHubLogs;